import { ReadEmployee } from "@/services/gql/graphql.generated";
import { FC } from "react";
import { FiFileText } from "react-icons/fi";
import { TSTitleCard } from "../../../../components/shared/card/Card";
import { useContract } from "../../../../services/contract/useContract";
import { strings } from "../../../../services/translation/strings";

export const ContractDetailsCard: FC<{employee: ReadEmployee}> = ({employee}) => {
  const contract = useContract(employee.contract?.contractTypeId);

  const ruleContainerClass = 'flex flex-col gap-2';
  return (
    <TSTitleCard className="bg-white"
      title={strings.timeshift.teamMember.contractDetails.cardTitle} 
      icon={FiFileText}>
        <div className="grid grid-cols-2 gap-4">
          <div className={ruleContainerClass}>
            <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.contractName}</span>
            <span>{contract?.name ?? '-'}</span>
          </div>
          <div className={ruleContainerClass}>
            <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.roleName}</span>
            <span>{employee.role}</span>
          </div>
          <div className={ruleContainerClass}>
            <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxDayHours}</span>
            <span>{contract && contract.maxHoursPerDay ? contract.maxHoursPerDay : '-'}</span>
          </div>
          <div className={ruleContainerClass}>
            <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxShiftHours}</span>
            <span>{contract ? contract.maxHoursPerShift : '-'}</span>
          </div>
        </div>
    </TSTitleCard>
  );
}
